import(/* webpackMode: "eager" */ "/app/apps/gpsmob/src/app/error.tsx");
